
export default (arg) => {
  if (arg && !Array.isArray(arg)) {
    return [arg];
  }
  return arg;
};
